import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import api from '../../lib/api';

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const error = location.state?.error;

  useEffect(() => {
    api.get('/auth/me')
      .then(() => navigate('/admin', { replace: true }))
      .catch(() => setChecking(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-deep px-5">
      <SEO title="Admin Login | INSIGHTS STRATEGY" description="Authorised access only." path="/admin/login" />
      <div className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#121412] p-10 text-center" data-testid="admin-login-card">
        <div className="mx-auto inline-block rounded-xl bg-white p-3">
          <img src="/assets/logo-header.webp" alt="INSIGHTS STRATEGY" className="h-auto w-[170px]" />
        </div>
        <h1 className="mt-6 font-heading text-xl font-bold text-white">Administration</h1>
        <p className="mt-2 text-xs leading-relaxed text-white/50">Content management for authorised administrators only.</p>
        {error && <p className="mt-4 rounded-lg bg-red-500/10 px-4 py-2.5 text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          onClick={login}
          disabled={checking}
          data-testid="admin-google-login-button"
          className="mt-8 w-full rounded-full bg-brand-green py-3.5 font-heading text-sm font-bold text-white transition-colors duration-300 hover:bg-brand-deepgreen disabled:opacity-50"
        >
          {checking ? 'Checking session…' : 'Sign in with Google'}
        </button>
        <a href="/" className="mt-6 inline-block text-xs text-white/40 transition-colors hover:text-brand-green" data-testid="admin-back-to-site">← Back to website</a>
      </div>
    </div>
  );
}
